import { useServicesContext } from "@/modules/core/services/services.context"
import { usersKeys } from "@/modules/users/gateway/usersKeys"
import { useQuery } from "@tanstack/react-query"

export function useCheckUsername(username?: string) {
  const { userProfileApi } = useServicesContext()

  const { data, isPending } = useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryKey: usersKeys.checkUsername(username!),
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return await userProfileApi.checkUsername(username!)
    },
    enabled: !!username,
  })
  return { data: data ?? false, isPending }
}
